module.exports = __webpack_public_path__ + "img/authentication-bg-dark.56e2a571.svg";